<template>
  <div v-if="externalQuestionnaire" class="e-module e-module--limited e-module--left e-module--transparent">
    <div class="external-questionnaire-wrapper">
      <div class="external-questionnaire-item">
        <h3>Hey! 👋 Hast du noch 2 Minuten Zeit?</h3>
        <p>Hilf uns, Nummer gegen Kummer noch besser zu machen!</p>
        <p>Deine Antworten sind anonym – das heißt: wir wissen nicht, wer du bist.</p>
        <button
            @click="openExternalQuestionnaire"
            class="el-button e-btn external-questionnaire-button"
          >
          Ja, ich mache mit!
          </button>
      </div>
    </div>
  </div>
  <FeedbackForm
  v-else
    :loading="loading"
    :entry-text="entryText"
    :form-fields="formFields"
  />
</template>

<script>
import api from 'api'
import FeedbackForm from 'organisms/Forms/Feedback/Feedback'

export default {
  components: {
    FeedbackForm
  },

  data: () => ({
    loading: false,
    entryText: '',
    formFields: []
  }),

  created() {
    this.getFormData()
  },
  computed: {
    externalQuestionnaire() {
      return window.externalQuestionnaire
    }
  },

  methods: {
    async getFormData() {
      this.loading = true

      try {
        const response = await api.call('getFeedbackData')
        this.entryText = response.data.results.entryText
        this.formFields = response.data.results.items
      } catch (error) {
        this.$error(error)
      } finally {
        this.loading = false
      }
    },
    openExternalQuestionnaire() {
      window.open(this.externalQuestionnaire, '_blank');
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .e-loading {
  display: block;
  margin: 0 auto;
}
.external-questionnaire-wrapper {
  background-color: white; 
  width: 90%; 
  height: 90%; 
  display: flex; 
  flex-direction: column; 
  align-items: flex-start; 
  justify-content: flex-start;
}
.external-questionnaire-item {
  margin: 40px;
}
.external-questionnaire-button {
  background-color: c('primary', dark);
  padding: 20px 40px; 
  margin-top: 40px;
}

.external-questionnaire-button:hover {
  background-color: c('primary');
}
</style>
